import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Bug, TrendingUp, TrendingDown, Minus } from "lucide-react";

const LEVEL_STYLE = {
  LOW: "bg-[#7C9673] text-white",
  MODERATE: "bg-amber-500 text-white",
  HIGH: "bg-red-600 text-white",
};

export default function PortalMildew() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/portal/mildew").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);

  if (rows === null) return <div className="bg-white border border-stone-200 h-28 animate-pulse" data-testid="mildew-loading" />;
  if (rows.length === 0) return null;

  return (
    <div data-testid="portal-mildew">
      <div className="text-xs font-bold uppercase text-stone-500 mb-2 flex items-center gap-2"><Bug size={14} /> Powdery Mildew Pressure</div>
      <div className="space-y-3">
        {rows.map((r) => {
          const delta = r.delta ?? (r.yesterday != null ? r.current_index - r.yesterday : null);
          const DeltaIcon = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
          return (
            <div key={r.ranch_number} className="bg-white border border-stone-200 p-4" data-testid={`mildew-card-${r.ranch_number}`}>
              <div className="flex flex-wrap items-center gap-4">
                <div>
                  <div className="text-[10px] font-bold uppercase text-stone-400">{r.ranch_number} · Index today</div>
                  <div className="flex items-center gap-2">
                    <span className="text-4xl font-bold" style={{ fontFamily: "'Fraunces', serif" }} data-testid={`mildew-index-${r.ranch_number}`}>{r.current_index}</span>
                    <span className={`text-[10px] font-bold uppercase px-2 py-1 ${LEVEL_STYLE[r.level] || "bg-stone-200"}`} data-testid={`mildew-level-${r.ranch_number}`}>{r.level}</span>
                  </div>
                </div>
                {delta != null && (
                  <div className={`flex items-center gap-1 text-sm font-bold ${delta > 0 ? "text-red-600" : delta < 0 ? "text-[#7C9673]" : "text-stone-400"}`}>
                    <DeltaIcon size={16} /> {delta > 0 ? `+${delta}` : delta} vs prior day
                  </div>
                )}
                <div className="flex-1" />
                <div className="flex gap-1.5" data-testid={`mildew-forecast-${r.ranch_number}`}>
                  {(r.forecast || []).slice(0, 5).map((f) => (
                    <div key={f.date} className="text-center border border-stone-200 px-2 py-1.5 min-w-[52px]">
                      <div className="text-[9px] font-mono text-stone-400">{f.date.slice(5)}</div>
                      <div className="font-bold text-sm">{f.index}</div>
                      <div className={`text-[8px] font-bold uppercase px-1 ${LEVEL_STYLE[f.level] || "bg-stone-100 text-stone-500"}`}>{f.level}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-2 text-[10px] text-stone-400">
                {r.model} · as of {r.current_date} · {r.location_name || r.station}{r.reason ? ` · ${r.reason}` : ""}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
